import styled, { css } from "styled-components";

const DeliveryBackupCardStyled = styled.div`
    border: 1px solid #A5A6A8;
    border-radius: 5px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 520px;
    justify-content: space-between;


    .mainTitle{
        font-size: 1.6rem;
        font-weight: 700;
        color: #1B1E1C;
    }

    .content {
        font-size: 1.3rem;
        font-weight: 400;
        color: #1B1E1C;
    }

    .grayText {
        color: #757575;
    }

    .sectionWrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
     }

    .addressContent {
        display: flex;
        flex-direction: column;
        gap: 4px;
        }

    .linkSection {
        display: flex;
        gap: 8px;
        font-size: 1.3rem;
        font-weight: 400;
        align-items: center;
        border-bottom: 1px solid #A5A6A8;
        padding-bottom: 16px;

        & > a {
            cursor: pointer;
            font-size: 1.3rem;
            font-weight: 700;
            color: #008755;
        }
     }

    .semiTitle {
        font-weight: 700;
     }

    .handlersWrapper {
        display: flex;
        justify-content: flex-end;
        gap: 24px;
        flex-direction: row;
    }

    .handlers {
        display: flex;
        gap: 8px;
        font-size: 1.5rem;
        font-weight: 700;
        color: #1B1E1C;
        align-items: center;
        color: #3D4543;
        cursor: pointer;
     }

    .greenHandler {
        color: #008755;
    }
   
`

export { DeliveryBackupCardStyled };